import React, { useEffect, useRef, useState } from "react";
import {
  CommonHeader,
  ErrorSuccessModal,
  Loader,
  TableHeader,
} from "../../../components/commons";
import JobChecklistSummary from "../../../components/JobListing/JobChecklist/JobChecklistSummary";
import { RootState } from "../../../redux/rootReducers";
import { connect } from "react-redux";
import { resetSession } from "../../../redux/auth";
import {
  getAllOpenJobChecklistSingleDataAction,
  lockJobChecklistDataAction,
  resetAllOpenJobChecklistSingleData,
  resetError,
  resetJobChecklistData,
  resetMessage,
  resetStatusCode,
  resetSuccess,
  updateAllOpenJobChecklistAction,
} from "../../../redux/jobs";
import "./style.scss";
import { Progress } from "reactstrap";
import AllOpenJobChecklistTableData from "../../../components/JobListing/JobChecklist/AllOpenJobChecklistTableData";
import {
  AllOpenJobSingleChecklistDetailsType,
  FlattenedProcedureType,
  GetAllOpenJobCheckListDetailsPayloadType,
  JobSingleType,
  LockJobCheckListPayloadType,
  ProceduresType,
  UpdateAllOpenJobChecklistPayloadType,
} from "../../../commonTypes/jobsType";
import { ALL_OPEN_CHECKLIST_HEADER } from "../../../constant/tableHeadersConstants/Jobs/JobsTableHeader";
import UploadModalWithFileManager from "../../../components/InvoiceGeneration/UploadModal/UploadModalWithFileManager";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
import { LoginResponseType } from "../../../redux/auth/authTypes";
import ImageModal from "../../AdminReports/OpenItemsProgressReports/ImageModal";
import { singleImagePreview } from "../../../utils/invoiceGeneration/commonFunctions";
import {
  CheckCircleDarkIcon,
  PendingIcon,
  WarningIcon,
} from "../../../assets/images";
import { useParams } from "react-router-dom";

type AppProps = {
  history: any;
  token: string | null;
  success: number | null;
  fetching: boolean;
  error: string | null | undefined;
  message: string | null | undefined;
  statusCode: number | null;
  totalJobsCount: number;
  loginData: LoginResponseType;
  fileManagerFetching: boolean;
  allOpenJobChecklistSingleData: AllOpenJobSingleChecklistDetailsType[] | null;
  dispatchResetSession: () => void;
  dispatchResetError: () => void;
  dispatchResetSuccess: () => void;
  dispatchResetJobsList: () => void;
  dispatchResetMessage: () => void;
  dispatchResetStatusCode: () => void;
  dispatchLockJobChecklist: (data: LockJobCheckListPayloadType) => void;
  dispatchUpdateAllOpenJobChecklist: (
    data: UpdateAllOpenJobChecklistPayloadType
  ) => void;
  dispatchGetAllOpenJobSingleJobCheckListData: (
    data: GetAllOpenJobCheckListDetailsPayloadType
  ) => void;
  dispatchResetJobChecklist: () => void;
  dispatchResetAllOpenJobChecklistSingleData: () => void;
};

const AllOpenJobChecklist = ({
  token,
  success,
  fetching,
  error,
  statusCode,
  history,
  loginData,
  fileManagerFetching,
  allOpenJobChecklistSingleData,
  dispatchResetSession,
  dispatchResetError,
  dispatchResetSuccess,
  dispatchResetMessage,
  dispatchResetStatusCode,
  dispatchLockJobChecklist,
  dispatchUpdateAllOpenJobChecklist,
  dispatchGetAllOpenJobSingleJobCheckListData,
  dispatchResetAllOpenJobChecklistSingleData,
}: AppProps) => {
  let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
  let blobToken = process.env.REACT_APP_BLOB_TOEKN;

  let { checklist_id, job_id }: any = useParams();
  const [showFileUploadModal, setShowFileUploadModal] =
    useState<boolean>(false);
  const [uploadData, setUploadData] = useState<any[]>([]);
  const [comment, setComment] = useState<string>("");
  const [data, setData] = useState<ProceduresType>([]);
  const [singleJobData, setJobSingleData] = useState<JobSingleType | any>({});
  const [imageDetails, setImageDetails] = useState<any>({
    imageUrl: "",
    downloadImage: "",
    fileType: "",
    finalFileName: "",
    updateBy: "",
    updatedAt: "",
  });
  const isLocked = useRef<boolean>(false);
  const [procedureFileId, setProcedureFileId] = useState<null | string>(null);
  const [showImagePreview, setShowImagePreview] = useState<boolean>(false);
  const [showPopUpContentModal, setShowPopUpContentModal] =
    useState<boolean>(false);
  const [flattenedData, setFlattenedData] = useState<
    FlattenedProcedureType[] | []
  >([]);

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
    });
    dispatchResetError();
    dispatchResetSuccess();
    dispatchResetMessage();
    dispatchResetStatusCode();
    dispatchResetAllOpenJobChecklistSingleData();
    if (token && job_id && checklist_id) {
      let finalData = {
        token,
        jobId: job_id,
        jobChecklistId: checklist_id,
      };
      dispatchGetAllOpenJobSingleJobCheckListData(finalData);
      dispatchResetAllOpenJobChecklistSingleData();
    }
  }, [checklist_id]);

  useEffect(() => {
    return () => {
      dispatchResetAllOpenJobChecklistSingleData();
      if (job_id && checklist_id && !isLocked?.current) {
        let data = {
          jobId: job_id,
          checkListId: checklist_id,
          token,
          shouldLock: false,
        };
        dispatchLockJobChecklist(data);
      }
    };
  }, []);

  useEffect(() => {
    if (
      allOpenJobChecklistSingleData &&
      allOpenJobChecklistSingleData?.length > 0
    ) {
      if (
        allOpenJobChecklistSingleData[0]?.is_lock_details?.is_lock &&
        allOpenJobChecklistSingleData[0]?.is_lock_details?.lock_updated_by
          ?.user_id !== loginData?.user_id
      ) {
        isLocked.current = true;
      } else if (!allOpenJobChecklistSingleData[0]?.is_lock_details?.is_lock) {
        isLocked.current = false;
      }
    }
  }, [allOpenJobChecklistSingleData]);

  useEffect(() => {
    if (showImagePreview) {
      setImageDetails({
        ...data,
        imageUrl: blobBaseUrl + uploadData[0]?.file_url + "?" + blobToken,
        downloadImage: uploadData[0]?.file_url,
        fileType: uploadData[0]?.file_type,
        finalFileName: uploadData[0]?.file_name,
      });
    }
  }, [showImagePreview]);

  useEffect(() => {
    if (
      allOpenJobChecklistSingleData &&
      allOpenJobChecklistSingleData?.length > 0 &&
      allOpenJobChecklistSingleData[0]?._id
    ) {
      if (
        !allOpenJobChecklistSingleData[0]?.is_lock_details?.is_lock &&
        job_id &&
        checklist_id
      ) {
        let data = {
          jobId: job_id,
          checkListId: checklist_id,
          token,
          shouldLock: true,
        };
        dispatchLockJobChecklist(data);
      }

      setJobSingleData(allOpenJobChecklistSingleData[0]?.job_details);
      setData([...allOpenJobChecklistSingleData[0]?.procedures]);
    }
  }, [allOpenJobChecklistSingleData]);

  const removeDuplicate = (data: any) => {
    let nonRepeatData: any = new Set();

    data?.forEach(
      (obj: any) =>
        !nonRepeatData.has(JSON.stringify(obj)) &&
        nonRepeatData.add(JSON.stringify(obj))
    );

    let finalData: any = new Set(
      [...nonRepeatData].map((item) => JSON.parse(item))
    );
    return finalData;
  };

  const handleUploadFile = (data: any) => {
    setShowFileUploadModal(false);
    let finalData: any = removeDuplicate(data);
    setUploadData(Array.from(finalData));
  };

  const flatten: any = (data: any) => {
    let procedureCount = 0;
    let subCount = 0;
    let firstLevelCount = 0;
    let secondLevelCount = 0;
    let thirdLevelCount = 0;

    const result = [];
    if (data?.length > 0) {
      for (const item of data) {
        if (item?.key === "procedure") {
          result.push({
            ...item,
            children: item.subHeading?.length > 0 ? true : false,
            count: ++procedureCount,
          });
        } else if (item?.key === "sub") {
          result.push({
            ...item,
            children: item.firstLevel?.length > 0 ? true : false,
            count: ++subCount,
          });
        } else if (item?.key === "firstLevel") {
          result.push({
            ...item,
            children: item.secondLevel?.length > 0 ? true : false,
            count: ++firstLevelCount,
          });
        } else if (item?.key === "secondLevel") {
          result.push({
            ...item,
            children: item.thirdLevel?.length > 0 ? true : false,
            count: ++secondLevelCount,
          });
        } else {
          result.push({ ...item, count: ++thirdLevelCount });
        }

        if (item.subHeading) {
          result.push(...flatten(item.subHeading));
        }
        if (item.firstLevel) {
          result.push(...flatten(item.firstLevel));
        }
        if (item.secondLevel) {
          result.push(...flatten(item.secondLevel));
        }
      }
    }

    return result;
  };

  const handleDropDownChange = (
    data: TableHeadersType,
    procedureId: string,
    index: number
  ) => {
    let newData = JSON.parse(JSON.stringify(flattenedData));
    newData[index] = {
      ...newData[index],
      details: { ...newData[index]?.details, status: data?.value },
    };
    setFlattenedData([...newData]);
    if (job_id && checklist_id) {
      let finalData = {
        token,
        jobId: +job_id,
        checkListId: checklist_id,
        procedureId,
        status: data?.value,
      };
      dispatchUpdateAllOpenJobChecklist(finalData);
    }
  };

  const handleCommentChange = (e: any, index: number) => {
    let value = e?.target?.value;
    setComment(value);
    let data = JSON.parse(JSON.stringify(flattenedData));
    data[index] = {
      ...data[index],
      details: { ...data[index]?.details, comments: value },
    };
    setFlattenedData([...data]);
  };

  const resetImageUrl = () => {
    setImageDetails({
      imageUrl: "",
      downloadImage: "",
      fileType: "",
      finalFileName: "",
      updateBy: "",
      updatedAt: "",
    });
  };

  const handleSubmitComment = (procedureId: string) => {
    if (job_id && checklist_id) {
      let finalData = {
        token,
        jobId: +job_id,
        checkListId: checklist_id,
        procedureId,
        comment,
      };
      dispatchUpdateAllOpenJobChecklist(finalData);
    }
  };

  const handleApprovalChange = (procedureId: string, index: number) => {
    let newData = JSON.parse(JSON.stringify(flattenedData));
    let loggedInUser = {
      user_id: loginData?.user_id,
      profile_pic: loginData?.profile_pic,
      first_name: loginData?.first_name,
      last_name: loginData?.last_name,
    };
    newData[index] = {
      ...newData[index],
      details: {
        ...newData[index]?.details,
        approver_details: [
          ...newData[index]?.details?.approver_details,
          { ...loggedInUser },
        ],
      },
    };
    setFlattenedData([...newData]);
    if (job_id && checklist_id) {
      let finalData = {
        token,
        jobId: +job_id,
        checkListId: checklist_id,
        procedureId,
        isBeingApproved: 1,
      };
      dispatchUpdateAllOpenJobChecklist(finalData);
    }
  };

  const handleToggleFileUploadModal = () => {
    setUploadData([]);
    setShowFileUploadModal(!showFileUploadModal);
  };

  const handleUploadFileFromFileManager = (data: any) => {
    let finalFileData: any = removeDuplicate(data);
    setUploadData(Array.from(finalFileData));
    let newData = JSON.parse(JSON.stringify(flattenedData));
    let finalNewData = newData?.map((item: any) => {
      if (item?._id === procedureFileId) {
        return {
          ...item,
          details: { ...item?.details, attachments: Array.from(finalFileData) },
        };
      } else {
        return item;
      }
    });
    setFlattenedData([...finalNewData]);

    if (procedureFileId && job_id && checklist_id) {
      let finalData = {
        token,
        jobId: +job_id,
        checkListId: checklist_id,
        procedureId: procedureFileId,
        attachedLink: Array.from(finalFileData),
      };
      dispatchUpdateAllOpenJobChecklist(finalData);
    }

    handleToggleFileUploadModal();
  };

  const getImageDetails = (data: any, index: any) => {
    setImageDetails({
      ...data,
      imageUrl: blobBaseUrl + data?.file_url + "?" + blobToken,
      downloadImage: data?.file_url,
      fileType: data?.file_type,
      finalFileName: data?.file_name,
    });
  };

  const handleEditFileList = (index: number) => {
    const updatedFiles = [...uploadData];
    setUploadData(updatedFiles?.filter((e: any) => e?.file_url !== index));
  };

  const handleFilePreviewData = (index: number) => {
    let newData = JSON.parse(JSON.stringify(flattenedData));
    setUploadData([...newData[index]?.details?.attachments]);
    setShowImagePreview((prev: boolean) => !prev);
  };

  const renderFilesList = () => {
    const isDelete = false;
    const finalFileList =
      uploadData?.length > 0 &&
      uploadData?.map((data: any, index: number) => {
        return singleImagePreview(
          data,
          index,
          getImageDetails,
          handleEditFileList,
          setShowPopUpContentModal,
          isDelete,
          uploadData
        );
      });
    return finalFileList;
  };

  const handleUploadSingleProcedureFile = (
    index: number,
    procedureId: string
  ) => {
    setProcedureFileId(procedureId);
    let newData = JSON.parse(JSON.stringify(flattenedData));
    setUploadData([...newData[index]?.details?.attachments]);

    setShowFileUploadModal((prev: any) => !prev);
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetError();
              dispatchResetMessage();
              dispatchResetStatusCode();
              dispatchResetSuccess();
              dispatchResetAllOpenJobChecklistSingleData();
              if (token && job_id && checklist_id) {
                let finalData = {
                  token,
                  jobId: job_id,
                  jobChecklistId: checklist_id,
                };
                dispatchGetAllOpenJobSingleJobCheckListData(finalData);
              }
            }}
          />
        );
      }
    }
  };

  useEffect(() => {
    let flattenData = flatten(data);
    setFlattenedData(flattenData);
  }, [data]);

  return (
    <div>
      <div>
        <CommonHeader title="Job Checklist" />
      </div>

      <div className="col-md-12 mt-4 job_checklist">
        <JobChecklistSummary
          header={[
            "jobIdType",
            "description",
            "CurrentlyResposible",
            "status",
            "startDate",
            "targetEndDate",
            "estimatedHour",
          ]}
          singleJobData={singleJobData}
        />

        <div className="new-table-card mt-3">
          <div className="p-3">
            <p className="checklist_header">Checklist Progress Summary</p>

            <div>
              <Progress
                striped
                style={{
                  height: "15px",
                  marginRight: "10px",
                  width: "100%",
                  backgroundColor: "#bfcbe1",
                }}
                value={singleJobData?.status_count}
                max={singleJobData?.total_count}
                color={
                  singleJobData?.status_count < singleJobData?.total_count
                    ? "warning"
                    : "success"
                }
              ></Progress>

              <div className="d-flex justify-content-between pt-2">
                <p>
                  {singleJobData?.status_count} / {singleJobData?.total_count}
                </p>
                <div
                  className={
                    singleJobData?.status_count < singleJobData?.total_count
                      ? "warning"
                      : "success"
                  }
                >
                  <span className="mr-2">
                    <img
                      width={18}
                      src={
                        singleJobData?.status_count < singleJobData?.total_count
                          ? PendingIcon
                          : CheckCircleDarkIcon
                      }
                      alt="progess"
                    />
                  </span>{" "}
                  <span>
                    {singleJobData?.status_count < singleJobData?.total_count
                      ? "In Progress"
                      : "Completed"}
                  </span>
                </div>
              </div>
            </div>

            {isLocked?.current ? (
              <div className="mt-1 mb-2 lock_warning">
                {" "}
                <span>
                  <img src={WarningIcon} alt="warning" />
                </span>{" "}
                {allOpenJobChecklistSingleData &&
                  allOpenJobChecklistSingleData[0]?.is_lock_details
                    ?.lock_updated_by?.first_name}{" "}
                {allOpenJobChecklistSingleData &&
                  allOpenJobChecklistSingleData[0]?.is_lock_details
                    ?.lock_updated_by?.last_name}{" "}
                is working on it please try again after some time
              </div>
            ) : null}
          </div>

          <div style={{ width: "100%", wordWrap: "break-word" }}>
            <table className=" mb-0 table table-bordered">
              <thead>
                <TableHeader tableHeader={ALL_OPEN_CHECKLIST_HEADER} />
              </thead>
              <tbody>
                <AllOpenJobChecklistTableData
                  data={flattenedData}
                  isLocked={isLocked.current}
                  handleDropDownChange={handleDropDownChange}
                  header={ALL_OPEN_CHECKLIST_HEADER}
                  setShowFileUploadModal={setShowFileUploadModal}
                  handleCommentChange={handleCommentChange}
                  handleSubmitComment={handleSubmitComment}
                  handleApprovalChange={handleApprovalChange}
                  setShowImagePreview={setShowImagePreview}
                  loginData={loginData}
                  handleUploadSingleProcedureFile={
                    handleUploadSingleProcedureFile
                  }
                  handleFilePreviewData={handleFilePreviewData}
                />
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {showFileUploadModal && (
        <UploadModalWithFileManager
          type={"invoice"}
          isDropZone={false}
          modal={showFileUploadModal}
          toggleModal={handleToggleFileUploadModal}
          setUploadData={setUploadData}
          uploadData={uploadData}
          token={token}
          client_code={singleJobData?.client_code}
          setShowFileUploadModal={setShowFileUploadModal}
          handleUploadFile={handleUploadFile}
          handleUploadFileFromFileManager={handleUploadFileFromFileManager}
          fetching={fileManagerFetching}
          isDraggableModal
        />
      )}

      {showImagePreview && (
        <ImageModal
          showImagePreview={showImagePreview}
          setShowImagePreview={setShowImagePreview}
          resetImageUrl={resetImageUrl}
          imageDetails={imageDetails}
          renderFilesList={renderFilesList}
          uploadData={uploadData}
          setUploadData={setUploadData}
          type={"jobDetails"}
          handleEditFileList={handleEditFileList}
          isDelete={false}
        />
      )}
      {handleErrorModal()}
      {fetching && <Loader />}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  loginData: state.auth.loginData,
  jobsList: state.jobs.jobsList,
  totalJobsCount: state.jobs.totalJobsCount,
  fetching: state.jobs.fetching,
  success: state.jobs.success,
  statusCode: state.jobs.statusCode,
  error: state.jobs.error,
  message: state.jobs.message,
  allOpenJobChecklistSingleData: state.jobs.allOpenJobChecklistSingleData,
  fileManagerFetching: state.fileManager.fetching,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetSuccess: () => dispatch(resetSuccess()),
  dispatchResetMessage: () => dispatch(resetMessage()),
  dispatchResetError: () => dispatch(resetError()),
  dispatchResetStatusCode: () => dispatch(resetStatusCode()),
  dispatchLockJobChecklist: (data: LockJobCheckListPayloadType) =>
    dispatch(lockJobChecklistDataAction(data)),
  dispatchUpdateAllOpenJobChecklist: (
    data: UpdateAllOpenJobChecklistPayloadType
  ) => dispatch(updateAllOpenJobChecklistAction(data)),
  dispatchGetAllOpenJobSingleJobCheckListData: (
    data: GetAllOpenJobCheckListDetailsPayloadType
  ) => dispatch(getAllOpenJobChecklistSingleDataAction(data)),
  dispatchResetJobChecklist: () => dispatch(resetJobChecklistData()),
  dispatchResetAllOpenJobChecklistSingleData: () =>
    dispatch(resetAllOpenJobChecklistSingleData()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllOpenJobChecklist);
